<nav class="sidebar-nav">
  @for (item of menuItems; track item.id) {
    
    <button 
      class="nav-item" 
      [class.active]="activeId() === item.id || (item.id === 'documents' && isChildActive(item))"
      (click)="selectView(item.id)">
      <span class="material-symbols-outlined">{{ item.icon }}</span>
      {{ item.label }}
    </button>

    @if (item.children && (activeId() === item.id || isChildActive(item))) {
      <div class="sub-menu-container">
        @for (sub of item.children; track sub.id) {
          <button 
            class="nav-item sub-item" 
            [class.active]="activeId() === sub.id"
            (click)="selectView(sub.id)">
            <span class="material-symbols-outlined">{{ sub.icon }}</span>
            {{ sub.label }}
          </button>
        }
      </div>
    }
  }
</nav>